<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('menu.workOrders')" name="detail">
          <div class="drawer-content with-tab">
            <el-form
              ref="workOrderForm"
              :model="workOrder"
              class="box"
              label-width="80px"
            >
              <fieldset class="mgb15">
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('workOrder.serialNo')">
                      <span v-if="workOrder.hurry" class="red">
                        ({{ $t("order.hurrySimple") }}) </span
                      >{{ workOrder.serialNo }}</el-form-item
                    >
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.serialNo')">{{
                      workOrder.orderSerialNo
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.innerSerialNo')">{{
                      workOrder.orderInnerSerialNo
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.workflowState')">
                      <state-label :state="workOrder.workflowState">{{
                        $t("workOrderStates." + workOrder.workflowState)
                      }}</state-label>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.handler')"
                      >{{ workOrder.handler }}/{{
                        workOrder.handleDepart
                      }}</el-form-item
                    >
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.printAt')">{{
                      workOrder.printedAt
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.handOverAt')">{{
                      workOrder.handOverAt
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.dispatchAt')">{{
                      workOrder.createdAt
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      :label="$t('order.planEndAt')"
                      label-width="100px"
                      >{{ workOrder.planEndAt }}</el-form-item
                    >
                  </el-col>
                </el-row>
                <el-row>
                  <el-col v-if="workOrder.processedAt != null" :span="8">
                    <el-form-item
                      :label="$t('workOrder.processedAt')"
                      label-width="100px"
                      >{{ workOrder.processedAt }}</el-form-item
                    >
                  </el-col>
                  <el-col v-if="workOrder.finishAt != null" :span="8">
                    <el-form-item
                      :label="$t('workOrder.finishAt')"
                      label-width="100px"
                      >{{ workOrder.finishAt }}</el-form-item
                    >
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>
                  {{ $t("order.productInfo") }}
                  <a
                    v-if="workOrder.attachment"
                    class="fr blue"
                    target="_blank"
                    :href="workOrder.attachment"
                  >
                    {{ $t("action.downloadAttatchment") }}
                  </a>
                </legend>

                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.productNo')">
                      {{ workOrder.productNo }}
                      <small
                        v-if="
                          workOrder.customerProductNo != null &&
                          workOrder.customerProductNo != ''
                        "
                      >
                        ({{ workOrder.customerProductNo }})
                      </small>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.category')">
                      {{ workOrder.categoryName }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.color')">
                      <span class="float-left mgr5">{{ workOrder.color }}</span>
                      <thumbnail
                        class="mgt5"
                        v-if="workOrder.colorImage != null"
                        :images="workOrder.colorImage"
                        width="25"
                        height="25"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.size')">
                      {{ workOrder.size }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.quantity')">
                      {{ workOrder.quantity }} {{ workOrder.unit }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset
                v-if="
                  workOrder.spec != null &&
                  workOrder.spec != '' &&
                  JSON.parse(workOrder.spec).length != 0
                "
                class="mgb15"
              >
                <legend>{{ $t("product.specJson") }}</legend>
                <el-tag
                  v-for="s in JSON.parse(workOrder.spec)"
                  :key="s.name"
                  type="info"
                  >{{ s.name }}：{{ s.value }}</el-tag
                >
              </fieldset>
              <fieldset v-if="workOrder.images != null" class="mgb15">
                <legend>{{ $t("product.images") }}</legend>
                <thumbnail :images="workOrder.images" list></thumbnail>
              </fieldset>
              <fieldset class="mgb15">
                <legend>{{ $t("product.craftwork") }}</legend>
                <raw-html :content="workOrder.craftwork" type="richText" />
              </fieldset>
              <fieldset
                v-if="workOrder.remark != null && workOrder.remark != ''"
                class="mgb15"
              >
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="workOrder.remark" type="richText" />
              </fieldset>
              <fieldset v-if="workOrder.cancelAt" class="mgb15">
                <legend>{{ $t("order.cancel") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.cancelAt')">
                      {{ workOrder.cancelAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item :label="$t('order.cancelReason')">
                      {{ workOrder.cancelReason }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('menu.phases')" name="phase">
          <div class="drawer-content with-tab">
            <vxe-table
              :data="workOrder.phasePlans"
              size="mini"
              resizable
              round
              auto-resize
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="phaseName"
                :title="$t('menu.phases')"
                min-width="80px"
              />
              <vxe-table-column
                v-if="showPhaseHourPrice == true"
                field="phaseHour"
                :title="$t('phaseTemplate.phaseHour')"
                min-width="90px"
              />
              <vxe-table-column
                v-if="showPhaseHourPrice == true"
                field="phasePrice"
                :title="$t('factory.phasePrice')"
                min-width="80px"
              >
                <template v-slot="{ row }">
                  {{ row.phasePrice | currency }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="period"
                :title="$t('phaseTemplate.period')"
                min-width="80px"
              />
              <vxe-table-column
                field="inspect"
                :title="$t('phaseTemplate.inspect')"
                min-width="50px"
              >
                <template v-slot="{ row }">
                  {{ $t("boolean." + row.inspect) }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="print"
                :title="$t('action.print')"
                min-width="50px"
              >
                <template v-slot="{ row }">
                  {{ $t("boolean." + row.print) }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="planEndAt"
                :title="$t('order.planEndAt')"
                min-width="110px"
              />
              <vxe-table-column
                field="manufactures"
                :title="$t('workOrder.productionSituation')"
                min-width="200px"
              >
                <template v-slot="{ row }">
                  <div
                    v-for="(manufacture, index) of row.manufactures"
                    :key="index"
                  >
                    <small>
                      {{ $t("menu.workers") }}:{{
                        manufacture.workerName
                      }}&nbsp;&nbsp; {{ $t("text.quantity") }}:{{
                        manufacture.quantity
                      }}&nbsp;&nbsp; {{ $t("text.startAt") }}:{{
                        manufacture.startAt
                      }}&nbsp;&nbsp; {{ $t("text.endAt") }}:{{
                        manufacture.endAt
                      }}
                    </small>
                  </div>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-if="receives.length != 0"
          :label="$t('workOrder.receiveRecords')"
          name="receive"
        >
          <div class="drawer-content with-tab">
            <vxe-table :data="receives" size="mini" resizable round auto-resize>
              <vxe-table-column field="quantity" :title="$t('text.quantity')" />
              <vxe-table-column
                field="receiveAt"
                :title="$t('workOrder.receiveAt')"
              />

              <vxe-table-column
                field="receiverName"
                :title="$t('workOrder.receiverName')"
              />
            </vxe-table>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-if="qas.length != 0"
          :label="$t('workOrder.qaRecords')"
          name="qa"
        >
          <div class="drawer-content with-tab">
            <vxe-table :data="qas" size="mini" resizable round auto-resize>
              <vxe-table-column field="quantity" :title="$t('text.quantity')" />
              <vxe-table-column
                field="checkAt"
                :title="$t('workOrder.checkAt')"
              />

              <vxe-table-column
                field="checkerName"
                :title="$t('workOrder.checkerName')"
              />
              <vxe-table-column field="voucher" :title="$t('payment.voucher')">
                <template v-slot="{ row }">
                  <thumbnail-text :srcs="row.voucher" />
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-if="reworks.length != 0"
          :label="$t('workOrder.reworkRecords')"
          name="rework"
        >
          <div class="drawer-content with-tab">
            <vxe-table :data="reworks" size="mini" resizable round auto-resize>
              <vxe-table-column
                field="quantity"
                :title="$t('text.quantity')"
                min-width="60px"
              />
              <vxe-table-column
                field="createAt"
                :title="$t('workOrder.checkAt')"
                width="110px"
              />
              <vxe-table-column
                field="checkerName"
                :title="$t('workOrder.checkerName')"
                min-width="80px"
              />
              <vxe-table-column
                field="phaseName"
                :title="$t('menu.phases')"
                min-width="80px"
              />
              <vxe-table-column
                field="workerName"
                :title="$t('menu.workers')"
                min-width="80px"
              />

              <vxe-table-column
                field="reason"
                :title="$t('rework.remark')"
                min-width="80px"
              >
                <template v-slot="{ row }">
                  <div>{{ row.type }}</div>
                  <raw-html-limit-number :content="row.reason" :number="8" />
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="voucher"
                :title="$t('payment.voucher')"
                min-width="90px"
              >
                <template v-slot="{ row }">
                  <thumbnail-text :srcs="row.voucher" />
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="finishAt"
                :title="$t('rework.finishAt')"
                width="110px"
              />
              <vxe-table-column
                v-if="Permit.canActionsChargeEdition('mesReworkFinish')"
                :title="$t('text.action')"
                width="50px"
              >
                <template v-slot="{ row }">
                  <el-button
                    v-if="row.finishAt == null"
                    type="text"
                    size="mini"
                    @click="finish(row)"
                    >{{ $t("action.finish") }}</el-button
                  >
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-if="shipments.length != 0"
          :label="$t('workOrder.shipSituation')"
          name="shipment"
        >
          <div class="drawer-content with-tab">
            <vxe-table
              :data="shipments"
              size="mini"
              resizable
              round
              auto-resize
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column field="quantity" :title="$t('text.quantity')" />
              <vxe-table-column
                field="shipAt"
                :title="$t('workOrder.shipAt')"
              />
              <vxe-table-column
                field="shiperName"
                :title="$t('workOrder.shiperName')"
              />
            </vxe-table>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('text.log')" name="log">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(log, index) in logs"
                  :key="index"
                  :timestamp="log.doAt"
                >
                  <span v-if="log.doBy != null" style="color: #909399">{{
                    log.doBy
                  }}</span>
                  <raw-html :content="log.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import RawHtml from "@/components/RawHtml";
import ThumbnailText from "@/components/ThumbnailText";
import WorkOrder from "@/api/workOrder.js";
import Qa from "@/api/qa.js";
import Rework from "@/api/rework.js";
import Receive from "@/api/receive.js";
import Shipment from "@/api/shipment.js";
import Log from "@/api/log.js";

export default {
  props: {
    id: Number,
    showPhaseHourPrice: {
      type: Boolean,
      defalut: true,
    },
  },
  mixins: [page],
  components: {
    RawHtml,
    ThumbnailText,
  },
  data() {
    return {
      activeName: "detail",
      Util: Util,
      workOrder: { hurry: null },
      qas: [],
      reworks: [],
      receives: [],
      shipments: [],
      logs: [],
    };
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    //
    finish(row) {
      const self = this;
      if (row.workerId != null) {
        if (confirm(self.$t("prompt.confirmFinish"))) {
          Rework.finish(row.id, {
            workerId: row.workerId,
            workerName: row.workerName,
          }).then(function (res) {
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.finishSuccess"),
                type: "success",
              });
              self.getReworks();
            } else {
              self.sysError();
            }
          });
        }
      }
    },
    //=====================
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getWorkOrder();
        this.getReceives();
        this.getQas();
        this.getReworks();
        this.getShipments();
      }

      // if (this.activeName == "receive") {
      //   this.getReceives();
      // }
      // if (this.activeName == "qa") {
      //   this.getQas();
      // }
      // if (this.activeName == "rework") {
      //   this.getReworks();
      // }

      // if (this.activeName == "shipment") {
      //   this.getShipments();
      // }
      if (this.activeName == "log") {
        this.getLogs();
      }
    },
    getWorkOrder() {
      const self = this;
      self.loadingStart();
      WorkOrder.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.workOrder = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getReceives() {
      const self = this;
      Receive.findByWorkerOrderId(self.id).then(function (res) {
        if (res.status === 200) {
          self.receives = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getQas() {
      const self = this;
      Qa.findByWorkerOrderId(self.id).then(function (res) {
        if (res.status === 200) {
          self.qas = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getReworks() {
      const self = this;
      Rework.findByWorkerOrderId(self.id).then(function (res) {
        if (res.status === 200) {
          self.reworks = res.data;
        } else {
          self.sysError();
        }
      });
    },

    getShipments() {
      const self = this;
      Shipment.findByWorkerOrderId(self.id).then(function (res) {
        if (res.status === 200) {
          self.shipments = res.data;
        } else {
          self.sysError();
        }
      });
    },

    getLogs() {
      const self = this;
      Log.forEntityMes("WorkOrder", self.id).then(function (res) {
        self.logs = res.data;
      });
    },
  },
};
</script>